<div class="view">
  <!-- <button class="btn btn-primary">
        <span routerLink="/">
            <img src="assets/images/icon/refresh.svg"> start over
        </span>
    </button> -->
</div>
